import { 
    UPDATE_CV_EXPERIENCES,
    UPDATE_CV_EXPERIENCES_SUCCESS,
    UPDATE_CV_EXPERIENCES_ERROR
} from '../../store/constants';

const initalState = {
    error: false,
    loading: false,
    success: false,
}

const reducer = (state = initalState, action) => {
    switch (action.type) {
        case UPDATE_CV_EXPERIENCES:
            return {...state, loading: true, error: false, success: false };
        case UPDATE_CV_EXPERIENCES_SUCCESS:
            return {...state, loading: false, success: true };
        case UPDATE_CV_EXPERIENCES_ERROR: 
            return {...state, loading: false, error: true };
        default: 
            return state;
    }
}

export default reducer;